import { useEffect, useState } from "react"
import ApartmentPriceTable from "../components/ApartmentPriceTable.js"
import { getPrices, getSurcharges } from "../utils/price.js"
import SurchargeList from "../components/SurchargeList.js"
import SEO from "../components/SEO.js"
import { getPriceSpecificationSchema } from "../utils/structuredData.js"
import drockerhofLogoSmall from '../assets/drockerhof-logo-small.svg'

const PricesPage = ({ text }) => {
    const [aptPrices, setAptPrices] = useState({})
    const [aptSurcharges, setAptSurcharges] = useState([])

    useEffect(() => {
        getPrices().then((prices) => setAptPrices(prices))
        getSurcharges().then((surcharges) => setAptSurcharges(surcharges))
    }, [])

    // Create price specifications for each apartment
    const priceSpecifications = Object.entries(aptPrices).map(([apartmentName, prices]) => {
        const apartmentTitle = text[`${apartmentName}Title`] || `${apartmentName} Apartment`;
        return {
            '@type': 'Product',
            'name': apartmentTitle,
            'offers': Object.entries(prices).map(([month, price]) =>
                getPriceSpecificationSchema({
                    price: price,
                    priceCurrency: 'EUR',
                    validFrom: `${new Date().getFullYear()}-${month}-01`,
                    validThrough: `${new Date().getFullYear()}-${month}-31`
                })
            )
        };
    });

    return (
        <>
            <SEO
                title={text.pricesTitle}
                description={text.pricesBody}
                structuredData={priceSpecifications}
                alternateUrls={[
                    { lang: 'de', url: 'https://www.drockerhof.it/de/prices' },
                    { lang: 'it', url: 'https://www.drockerhof.it/it/prices' },
                    { lang: 'en', url: 'https://www.drockerhof.it/en/prices' }
                ]}
            />
            <div className="drocker-body drocker-no-image">
                <div className="container">
                    <h1>{text.pricesTitle}</h1>
                    <p dangerouslySetInnerHTML={{ __html: text.pricesBody }} />
                    <p className="fw-lighter" dangerouslySetInnerHTML={{ __html: text.pricesIncludedServices }} />
                    <ApartmentPriceTable text={text} apartmentPrices={aptPrices} />
                    <SurchargeList text={text} apartmentSurcharges={aptSurcharges} />
                    <div className="text-center mt-3">
                        <img src={drockerhofLogoSmall} alt="Drockerhof Logo" width="120" height="46" className="d-inline-block align-text-top" loading="lazy" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default PricesPage
